import { Vue, Component } from 'vue-property-decorator'
import gql from 'graphql-tag'
import {
  Scalars,
  MediaImage,
  MediaVideo,
  MediaAudio,
  MediaAudioList,
  MediaVideoList,
  MediaImageList,
  PaginationOptions,
  SortArgs
} from '@/@types/graphql'

import {
  MediaImageFragment,
  MediaVideoFragment,
  MediaAudioFragment
} from './fragments'

@Component({
  name: 'media-service'
})
export default class Medias extends Vue {

  async GET_SINGLE_IMAGE (id: Scalars['UUID']): Promise<MediaImage> {
    const variables = { id }
    const query = gql`

        ${ MediaImageFragment }

        query image($id: UUID!) {
            image (id: $id) {
                ...MediaImageFragment
            }
        }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.image
  }

  async GET_ALL_IMAGE (
    pagination: PaginationOptions = {},
    sort: SortArgs = {}
  ): Promise<MediaImageList> {
    const variables = { pagination, sort }
    const query = gql`

        ${ MediaImageFragment }

        query images($pagination: PaginationArgs, $sort: SortArgs) {
            images (pagination: $pagination, sort: $sort) {
                ...MediaImageFragment
            }
        }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.images
  }

  async GET_SINGLE_VIDEO (id: Scalars['UUID']): Promise<MediaVideo> {
    const variables = { id }
    const query = gql`

      ${ MediaVideoFragment }

      query video($id: UUID!) {
        video (id: $id) {
          ...MediaVideoFragment
        }
      }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.video
  }

  async GET_ALL_VIDEO (
    pagination: PaginationOptions = {},
    sort: SortArgs = {}
  ): Promise<MediaVideoList> {
    const variables = { pagination, sort }
    const query = gql`

      ${ MediaVideoFragment }

      query videos($pagination: PaginationArgs, $sort: SortArgs) {
        videos (pagination: $pagination, sort: $sort) {
          ...MediaVideoFragment
        }
      }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.video
  }

  async GET_SINGLE_AUDIO (id: Scalars['UUID']): Promise<MediaAudio> {
    const variables = { id }
    const query = gql`

      ${ MediaAudioFragment }
      ${ MediaImageFragment }
      query audio($id: UUID!) {
        audio (id: $id) {
          ...MediaAudioFragment
        }
      }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.audio
  }

  async GET_ALL_AUDIO (
    pagination: PaginationOptions = {},
    sort: SortArgs = {}
  ): Promise<MediaAudioList> {
    const variables = { pagination, sort }
    const query = gql`
      ${ MediaAudioFragment }
      ${ MediaImageFragment }
      query audios($pagination: PaginationArgs, $sort: SortArgs) {
        audios (pagination: $pagination, sort: $sort) {
          items {
            ...MediaAudioFragment
          }
        }
      }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.audios
  }
}
